"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOutlinedInputTheme = void 0;
exports.createOutlinedInputTheme = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            fontFamily: "Gilroy",
            fontSize: 16,
            lineHeight: "20px",
            borderRadius: 32,
            color: palette.neutral.darkBlue,
            "&$focused": {
                color: palette.common.black,
            },
            "&$error": {
                color: palette.error.main,
                borderColor: palette.error.main,
                "&:hover $notchedOutline": {
                    borderColor: palette.error.main,
                    border: "1px solid",
                },
                "&$focused $notchedOutline": {
                    borderColor: palette.error.main,
                    border: "2px solid",
                },
            },
            "&$disabled": {
                "&:hover $notchedOutline": {
                    borderColor: palette.grey[400],
                    border: "1px solid",
                },
            },
            "&:hover $notchedOutline": {
                borderColor: palette.neutral.grey60,
                border: "1px solid",
            },
            "&$focused $notchedOutline": {
                borderColor: palette.primary.main,
                border: "2px solid",
            },
        },
        notchedOutline: {
            borderColor: palette.neutral.grey90,
            borderRadius: 32,
        },
        focused: {},
        error: {},
        disabled: {},
        multiline: {
            padding: "19px 30px",
            background: palette.common.white,
        },
        inputMultiline: {
            borderRadius: 0,
        },
        input: {
            padding: "19px 30px",
            background: palette.common.white,
            borderRadius: 32,
            "&::placeholder": {
                fontWeight: 400,
                color: palette.grey[400],
                opacity: 1,
            },
        },
    });
};
